import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  animations:[
  ]
})
export class PageComponent implements OnInit {
  show: boolean = true;

  constructor() { }

  ngOnInit(): void {
    setInterval(()=>{
      this.show = !this.show;
    },2*1000);
  }

}
